import { render, staticRenderFns } from "./CRTabs.vue?vue&type=template&id=b715465e&scoped=true"
import script from "./CRTabs.vue?vue&type=script&lang=js"
export * from "./CRTabs.vue?vue&type=script&lang=js"
import style0 from "./CRTabs.vue?vue&type=style&index=0&id=b715465e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b715465e",
  null
  
)

export default component.exports